import { i as r } from "../isExhaustive-RFXKPwPh.js";
import { l as a } from "../lookUpByPath-D0L99z-9.js";
function o(t) {
  return t.replace(/\s+/, " ").split(" ").slice(0, 2).map((e) => e && e[0].toUpperCase()).join("");
}
export {
  o as getInitials,
  r as isExhaustive,
  a as lookUpByPath
};
